import {Component, Inject, Input, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {FormControl} from '@angular/forms';
import {environment} from '../../../environments/environment';
import {ConfService} from '../../conf.service';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';
import {error} from 'selenium-webdriver';
@Component({
  selector: 'ap-import-variables',
  templateUrl: './import-variables.component.html',
  styleUrls: ['./import-variables.component.scss']
})
export class ImportVariablesComponent implements OnInit {

  partner = localStorage.getItem('partner');
  account = localStorage.getItem('account');

  inputformControl: FormControl = new FormControl({}, []);
  AddConnectorFlag = false;
  EditConnectorFlag = false;
  viewConnectorFlag = false;
  acceleratorConnectors: any;
  selectedAcceleratorConnector: any;
  selectedConnector: any;
  defaultAcceleratorConnector: any;
  integration_title: any;
  serviceProviderDepndencies: any;

  checkServiceProviders = false;

  @Input() inputVariables: any;
  @Input() inputs = [
    {
      name: 'Connector Variables',
      variables: []
    },
    {
      name: 'Accelerator Variables',
      variables: []
    }
  ];

  authModels = [
    {'display_name': 'API Key',
      'value': 'api_key'},
    {'display_name': 'Bearer Token',
      'value': 'bearer_token'},
    {'display_name': 'Basic Authorization',
      'value': 'basic_authentication'},
    {'display_name': 'OAuth 1.0',
      'value': 'oauth_1_0'},
    {'display_name': 'OAuth 2.0',
      'value': 'oauth_2_0'},
    {'display_name': 'AWS Signature',
      'value': 'aws_signature'},
    {'display_name': 'API Connectors',
      'value': 'connector'}];

  connectorName: any;

  currentPage = 'variables';
  subscriptionsDataLoading = true;

  subscribeLoading = false;

  currentSubscriptions: any;

  isValidServiceProviders = false;

  serviceProvidersListString = '';

  notSubscribedButRequiredProviders: any;

  subscriptionUpdated = false;

  dataSource = []; // Your data source

  // Arrays to track the selected state for isParameter, isHeader, and isPayload
  selectedParameter: any[] = [];
  selectedHeader: any[] = [];
  selectedPayload: any[] = [];

  // "Select all" properties for isParameter, isHeader, and isPayload
  selectAllParameter = false;
  selectAllHeader = false;
  selectAllPayload = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<ImportVariablesComponent>,
              public platform: LeftpanelComponent,
              private confSrv: ConfService) {
    if (data && data.accelerator_variables) {
      this.inputs[0].variables = JSON.parse(JSON.stringify(data.accelerator_variables));
    }
    if (data && data.connector_variables) {
      this.inputs[1].variables = JSON.parse(JSON.stringify(data.connector_variables));
      this.updateSelectedAccelertorConnector(this.inputs[1].variables);
    }
    if (data && data.acceleratorFlag) {
      this.AddConnectorFlag = JSON.parse(JSON.stringify(data.acceleratorFlag));
    }
    if (data && data.integration_title) {
      this.integration_title = JSON.parse(JSON.stringify(data.integration_title));
      this.getAcceleratorConnectors(this.integration_title);
    }
    if (data && data.connectorFlag) {
      this.EditConnectorFlag = JSON.parse(JSON.stringify(data.connectorFlag));
    }
    if (data && data.viewConnectorFlag) {
      this.viewConnectorFlag = JSON.parse(JSON.stringify(data.viewConnectorFlag));
    }
    if (data && data.name) {
      this.connectorName = JSON.parse(JSON.stringify(data.name));
    }
    if (data && data.serviceProviderDepndencies) {
      this.serviceProviderDepndencies = JSON.parse(JSON.stringify(data.serviceProviderDepndencies));
    }
    if (data && data.checkServiceProviders) {
      this.checkServiceProviders = true;
    }
  }

  ngOnInit() {
    if (this.data && this.data.checkServiceProviders) {
      this.currentPage = 'service_providers';
      this.subscriptionsDataLoading = true;
      if (this.serviceProviderDepndencies.length === 0) {
        this.currentPage = 'variables';
      } else {
        this.validateSubscriptions();
      }
    } else {
      this.currentPage = 'variables';
    }
  }

  toggleAll(type: string, variables, event) {
    const checked = event.checked
    if (checked) {
      for (const variable of variables) {
        if (type === 'isParameter') {
          variable['isParameter'] = true;
          variable['isHeader'] = false;
          variable['isPayload'] = false;
          this.selectAllParameter = true;
          this.selectAllHeader = false;
          this.selectAllPayload = false;
        } else if (type === 'isHeader') {
          variable['isHeader'] = true;
          variable['isParameter'] = false;
          variable['isPayload'] = false;
          this.selectAllParameter = false;
          this.selectAllHeader = true;
          this.selectAllPayload = false;
        } else if (type === 'isPayload') {
          variable['isPayload'] = true;
          variable['isHeader'] = false;
          variable['isParameter'] = false;
          this.selectAllPayload = true;
          this.selectAllHeader = false;
          this.selectAllParameter = false;
        }
      }
    } else {
      for (const variable of variables) {
        if (type === 'isParameter') {
          variable['isParameter'] = false;
        } else if (type === 'isHeader') {
          variable['isHeader'] = false;
        } else if (type === 'isPayload') {
          variable['isPayload'] = false;
        }
      }
    }
  }

  // Toggle the selection for a specific row and type
  toggleSelection(type: string, variable, event) {
    const checked = event.checked
    if (checked) {
      if (type === 'isParameter') {
        variable['isParameter'] = true;
        variable['isHeader'] = false;
        variable['isPayload'] = false;
      } else if (type === 'isHeader') {
        variable['isHeader'] = true;
        variable['isParameter'] = false;
        variable['isPayload'] = false;
      } else if (type === 'isPayload') {
        variable['isPayload'] = true;
        variable['isHeader'] = false;
        variable['isParameter'] = false;
      }
    } else {
      if (type === 'isParameter') {
        variable['isParameter'] = false;
      } else if (type === 'isHeader') {
        variable['isHeader'] = false;
      } else if (type === 'isPayload') {
        variable['isPayload'] = false;
      }
    }
  }

  // Check if all rows are selected for the given type
  isAllSelected(type: string, variables): boolean {
    const count = variables.filter((variable) => variable[type] === true).length;
    return count === variables.length;
  }

  // Check if some rows are selected and others are not for the given type
  isIndeterminate(type: string, variables): boolean {
    const count = variables.filter((variable) => variable[type] === true).length;
    return count > 0 && count < variables.length;
  }

  // A function to determine the state of an individual checkbox
  isSelected(row: any, type: string): boolean {
    if (type === 'isParameter') {
      return this.selectedParameter.includes(row);
    } else if (type === 'isHeader') {
      return this.selectedHeader.includes(row);
    } else if (type === 'isPayload') {
      return this.selectedPayload.includes(row);
    }
    return false;
  }

  validateSubscriptions() {
    Promise.resolve(this.getProviderSubscriptions().then(resp => {
      let res: any;
      res = resp;
      this.isValidServiceProviders = res.isValid;
      if (!res.isValid) {
        this.notSubscribedButRequiredProviders = res.providers;
        this.serviceProvidersListString = '';
        for (const val of this.notSubscribedButRequiredProviders) {
          if (this.serviceProvidersListString === '') {
            this.serviceProvidersListString = val.title;
          } else {
            this.serviceProvidersListString += ', ' + val.title;
          }
        }
      } else {
        this.currentPage = 'variables';
      }
      this.subscriptionsDataLoading = false;
      this.subscribeLoading = false;
    }, error => {
      this.platform.openSnackBar('Error while checking service provider subscriptions. Please try again later.', 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
      this.dialogRef.close(false);
    }));
  }

  updateSelectedAccelertorConnector(connectors: any) {
    this.defaultAcceleratorConnector = {
      connector_variables: []
    };
    const connector_variables: any = [];
    for (const connector of connectors) {
      connector_variables.push({
        name: connector.name,
        value: connector.value
      });
    }
    this.defaultAcceleratorConnector.connector_variables = connector_variables;
  }

  getProviderSubscriptions() {
    return new Promise((resolve, reject) => {
      const payload = {
        required: this.serviceProviderDepndencies,
        partner: this.partner,
        account: this.account,
      };
      this.confSrv.postIntegrationsApi(environment.integrationsAPI.validateProviderSubscriptions.name, environment.integrationsAPI.validateProviderSubscriptions.version, payload).subscribe(data => {
        this.currentSubscriptions = data;
        resolve(this.currentSubscriptions);
      }, error => {
        reject('Unable to load data');
      });
    });

  }

  postAcceleratorConnectors(connector: any) {
    if(connector.name !== '' && connector.name !== null && connector.name  !== undefined &&
        (connector.connector_variables.length > 0 ? connector.connector_variables.every(item => item.val !== ''): true)){

      return new Promise((resolve, reject) => {
        const payload = {
          significance: 'generate',
          intent: 'connectors',
          partner: this.partner,
          account: this.account,
          data: {
            name: connector.name,
            integration_title: this.integration_title,
            connector_variables: connector.connector_variables
          }
        };
        this.confSrv.postIntegrationsApi(environment.integrationsAPI.acceleratorConnectors.name, environment.integrationsAPI.acceleratorConnectors.version, payload).subscribe(data => {
          resolve();
        }, error => {
          reject('Unable to load data');
        });
      });
    } else {
      this.platform.openSnackBar('Please enter all mandatory fields', 'Error', {
        duration: 2000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }
  }

  getAcceleratorConnectors(integration_title: string) {
    return new Promise((resolve, reject) => {
      const payload = {
        significance: 'compose',
        intent: 'connectors',
        partner: this.partner,
        account: this.account,
        data: {
          integration_title: this.integration_title
        }
      };
      this.confSrv.postIntegrationsApi(environment.integrationsAPI.acceleratorConnectors.name, environment.integrationsAPI.acceleratorConnectors.version, payload).subscribe(data => {
        let resp: any;
        resp = data;
        this.acceleratorConnectors = resp.items;
        if (this.acceleratorConnectors.length) {
          this.selectedConnector = this.acceleratorConnectors[0];
          this.mapToAcceleratorConnectors(this.selectedConnector);
        }
        resolve();
      }, error => {
        reject('Unable to load data');
      });
    });
  }

  mapToAcceleratorConnectors(acceleratorConnector: any) {
    for (const a_connector of this.inputs[1].variables) {
      let valueFound = false;
      for (const s_connector of acceleratorConnector.connector_variables) {
        if (a_connector.name === s_connector.name) {
          a_connector.value = s_connector.val;
          valueFound = true;
        }
      }
      if (!valueFound) {
        a_connector.value = '';
      }
    }
    this.selectedAcceleratorConnector = {connector_variables:
      JSON.parse(JSON.stringify(this.inputs[1].variables))
    };
  }

  putAcceleratorConnectors(connector: any) {
    if(connector.name !== '' && connector.name !== null && connector.name  !== undefined &&
        (connector.connector_variables.length > 0 ? connector.connector_variables.every(item => item.val !== ''): true)) {
      return new Promise((resolve, reject) => {
        const payload = {
          significance: 'refurbish',
          intent: 'connectors',
          partner: this.partner,
          account: this.account,
          data: {
            name: connector.name,
            integration_title: this.integration_title,
            connector_variables: connector.connector_variables
          }
        };
        this.confSrv.postIntegrationsApi(environment.integrationsAPI.acceleratorConnectors.name, environment.integrationsAPI.acceleratorConnectors.version, payload).subscribe(data => {
          resolve();
        }, error => {
          reject('Unable to load data');
        });
      });
    } else{
      this.platform.openSnackBar('Please enter all mandatory fields', 'Error', {
        duration: 2000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }
  }

  updateSubscriptions() {
    const requiredProviders = [];
    for (const val of this.notSubscribedButRequiredProviders) {
      requiredProviders.push(val.id);
    }
    const payload = {
      significance: 'generate',
      intent: 'subscriptions',
      partner: this.partner,
      account: this.account,
      data: {
        service_providers: requiredProviders
      }
    };
    this.subscribeLoading = true;
    this.confSrv.postIntegrationsApi(environment.integrationsAPI.serviceProviderSubscriptions.name, environment.integrationsAPI.serviceProviderSubscriptions.version, payload).subscribe(data => {
      this.subscriptionUpdated = true;
      this.validateSubscriptions();
    }, error => {
      this.platform.openSnackBar('Error while subscribing to service provider. Please try again later.', 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
      this.dialogRef.close(false);
    });
  }

  updateConnectorData() {
    const connectorVariables: any[] = [];
    for (const connectorVariable of this.inputs[1].variables) {
      connectorVariables.push({
        name: connectorVariable.name,
        val: connectorVariable.val
      });
    }
    this.putAcceleratorConnectors({
      name: this.connectorName,
      connector_variables: connectorVariables
    }).then(r => {
      this.platform.openSnackBar('Connector updated successfully', 'Success', {
        duration: 6000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
      this.dialogRef.close(true)});
  }

  returnConnectorData() {
    const connectorVariables: any[] = [];
    for (const connectorVariable of this.inputs[1].variables) {
      connectorVariables.push({
        name: connectorVariable.name,
        val: connectorVariable.value
      });
    }
    this.postAcceleratorConnectors({
      name: this.connectorName,
      connector_variables: connectorVariables
    }).then(r => this.dialogRef.close(true));
  }

  returnVariables() {
    // if (this.selectedAcceleratorConnector) {
    //   this.mapToAcceleratorConnectors(this.selectedAcceleratorConnector);
    // }
    this.dialogRef.close({
      accelerator_variables: this.inputs[0].variables,
      connector_variables: this.inputs[1].variables,
      subscriptionUpdated: this.subscriptionUpdated
    });
  }

}
